<template>
  <div>
    <div
      v-if="!orders"
      class="text-xs-center pa-3"
    >
      <v-progress-circular
        :size="50"
        :width="7"
        color="primary"
        indeterminate
      />
    </div>
    <v-data-table
      v-if="orders"
      :headers="headers"
      :items="orders"
      item-key="idOrigem"
      :pagination.sync="pagination"
      class="orders-data-table"
    >
      <template slot="headers">
        <div />
      </template>
      <template
        slot="items"
        slot-scope="props"
        class="table-content"
      >
        <div
          class="text-xs-left table-content"
          @click="props.expanded = !props.expanded"
        >
          <td class="data">{{ props.item.data | filtraData }}</td>
          <td class="data">
            <strong> {{ props.item.loja ? props.item.loja : 'Loja não cadastrada na CRM360' }} </strong><br>
            <div class="mt-1">{{ props.item.vendedor }}</div>
          </td>
          <td class="total-venda">{{ (props.item.totalVenda ? props.item.totalVenda : (props.item.items | somaItems)) | currency }}</td>
        </div>
      </template>
      <template
        slot="expand"
        slot-scope="props"
      >
        <table
          style="width: 100%"
          class="bordaTable"
        >
          <thead>
            <tr class="text-xs-left">
              <th style="width: 80%">
                Produto
              </th>
              <th style="width: 20%">
                Tamanho
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in props.item.items"
              :key="item.idOrigem"
              class="text-xs-left"
            >
              <td>{{ item.quantidade }} x {{ item.descricao }}</td>
              <td>{{ item.numeracao }}</td>
            </tr>
          </tbody>
        </table>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import format from 'date-fns/format';
import { APIService } from '@/resources/campanha.js';

const api = new APIService();

export default {
  filters: {
    filtraData(value) {
      if (value) {
        return format(value, 'DD/MM/YY');
      }
    },
    somaItems(value) {
      return value.map((a) => a.valorUnitario).filter((a) => a).reduce((a, b) => a + b, 0) - value.map((a) => a.desconto).filter((a) => a).reduce((a, b) => a + b, 0);
    },
  },
  props: {
    contato: Object,
  },
  data: () => ({
    orders: null,
    pagination: {
      descending: true,
      sortBy: 'data',
    },
    headers: [
      {
        text: 'Data',
        value: 'data',
        sortable: true,
      },
      { text: 'Loja', value: 'loja', sortable: false },
      { text: 'Total', value: 'valorTotal', sortable: false },
    ],
  }),
  computed: {},
  created() {},
  mounted() {
    this.getSalesHistory();
  },
  methods: {
    async getSalesHistory() {
      const res = await api.getSalesHistory(
        this.contato.customerId,
        this.contato.idERP,
      );
      this.orders = res;
    },
  },
};
</script>

<style scoped>
.bordaTable{
        border-bottom: 1px solid rgba(0,0,0,0.12);
}
::v-deep .orders-data-table {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: bold !important;;
  font-size: 12px !important;
  line-height: 16px !important;;
}
::v-deep  .total-venda {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: bold !important;
  font-size: 12px !important;;
  line-height: 16px !important;;
  color: #0C4439 !important;;
}
.data {
  font-family: 'Nunito Sans';
  font-style: normal !important;
  font-size: 12px !important;
  line-height: 16px !important;
  font-weight: 600 !important;
}
::v-deep .table-content {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
  vertical-align: middle;
  border-bottom: 0.829458px solid #8A8691;}
</style>
